import $ from 'jquery';

function Quicklinks(element) {
  this.element = element;
  this.$clickable = this.getClickable();
  this.onClick = $.proxy(this.onClick, this);
  this.init();
}

Quicklinks.prototype = {
  init() {
    this.addListeners();
  },
  getClickable() {
    return $('.block-title', this.element);
  },
  onClick(event) {
    if ($(window).width() < 640) {
      $('#navigation').toggleClass('expand');
      event.preventDefault();
    }
  },
  addListeners() {
    $(document).find(this.$clickable).bind('click', this.onClick);
  },
};

export default Quicklinks;



// WEBPACK FOOTER //
// ./Quicklinks.js